<template>
  <div class="wysiwyg" v-html="data.Content"></div>
</template>

<script>
export default {
  name: 'Wysiwyg',
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style scoped lang="scss">
.wysiwyg {
  padding: 1.5rem 0;
  max-width: 92rem;

  ::v-deep {
    h2 {
      margin-bottom: 2rem;
      font-size: 1.8rem;
      line-height: 1.3;
      font-weight: 500;
    }

    h3 {
      margin-bottom: 1rem;
      font-size: 1.6rem;
      line-height: 2rem;
      font-weight: 600;
      color: $cMainDark;
      text-decoration: underline;
      padding-bottom: 2rem;

      &:not(:first-of-type) {
        margin-top: 3rem;
      }
    }

    p {
      margin-bottom: 1em;
      font-size: 1.6rem;
      line-height: 2.4rem;
      color: $cMainLight;

      @include rwd('tablet') {
        font-size: 1.4rem;
        line-height: 2rem;
      }

      &:last-of-type {
        margin-bottom: 0;
      }
    }

    ol {
      padding-left: 1em;
      list-style: none;
      counter-reset: list;
      font-size: 1.6rem;
      line-height: 2.4rem;
      color: $cMainLight;

      & > li {
        counter-increment: list;

        &::marker {
          content: counter(list, lower-alpha) ')\a0';
        }
      }

      &:nth-of-type(even) {
        list-style-type: decimal;

        & > li {
          &::marker {
            content: counter(list, decimal) '.\a0';
          }
        }
      }

      @include rwd('tablet') {
        font-size: 1.4rem;
        line-height: 2rem;
      }

      & ol {
        list-style: none;
        counter-reset: none;

        & > li {
          counter-increment: none;

          &::marker {
            content: '-\a0';
          }
        }
      }
    }
  }
}
</style>
